// Must match Management/Permissions/WorkSchedulePermissions.cs
export const schedulePermissions = {
    List: 35000,
    Create: 35001,
    Update: 35002,
    ShowDetails: 35003,
    Delete: 35004,
};

export const assignmentPermissions = {
    List: 36000,
    Create: 36001,
    Update: 36002,
    Delete: 36003,
};

export const periodPermissions = {
    List: 37000,
    Create: 37001,
    Update: 37002,
    Delete: 37003,
};

// Must match Management/Permissions/HolidayPermissions.cs
export const holidayPermissions = {
    List: 38000,
    Create: 38001,
    Update: 38002,
    Delete: 38003,
    // Apply or reverse the deduction of an unofficial holiday from leave balances.
    Approve: 38004,
};
